import './CategoryView.scss'
import {Button, Container} from "react-bootstrap";
import {useContext, useState} from "react";
import CategoryVideo from "./CategoryVideo";
import CategoryQuiz from "./CategoryQuiz";
import {BsChevronLeft} from "react-icons/bs";
import {useTranslation} from "react-i18next";
import {format_seconds} from "../Tools";
import ExtraVideoPlayer from "./ExtraVideoPlayer";
import API, {HandleError} from "../API";
import {User} from "../models/User";
import AppContext from "../AppContext";
import {useSnackbar} from "notistack";

export default function ExtraVideoView({ currentVideo, setCurrentVideo }) {
    const app = useContext(AppContext)
    const { enqueueSnackbar } = useSnackbar()
    const { t, i18n } = useTranslation();

    const closeVideo = () => {
        setCurrentVideo(null)
    }
    const submitVideoPlayed = async() => {
        //app.startLoading()
        try {
            const res = await API({
                method: 'POST',
                url: `/extra-videos/${currentVideo.course_id}`,
                headers: {
                    'Authorization': `Bearer ${app.token}`,
                },
                data: {
                    event: 'video_watched',
                    ref_id: currentVideo.ID
                }
            })

            if (res.status < 200 || res.status > 299)
                throw res.data;

            //app.stopLoading()
            app.setUser(new User(res.data.me));
        }
        catch(e) {
            //app.stopLoading()
            HandleError(e, 'Error', enqueueSnackbar, app.logout);
        }
    }

    return <div id="category-window">
        <div className="category-window-inner">
            <header className="category-header">
                <Container className="d-flex justify-content-start gap-5 align-items-start">
                    <Button onClick={closeVideo} variant="secondary" className="d-flex align-items-center gap-2">
                        <BsChevronLeft /> {t('button.back')}
                    </Button>
                    <div>
                        <h6 className="title" dangerouslySetInnerHTML={{__html: t('extraVideos.duration') + ': ' + format_seconds(currentVideo.duration)}} />
                        <h1 className="title" dangerouslySetInnerHTML={{__html: currentVideo.name}} />
                    </div>
                </Container>
            </header>
            <Container>
                <section id="category-main">
                    <ExtraVideoPlayer closeVideo={closeVideo} video={currentVideo} onVideoWatched={submitVideoPlayed} />
                </section>
            </Container>
        </div>
    </div>
}